import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { applyAuthTokensFromUrl } from "../utils/authTokens";

const PrivateRoute = ({ element }) => {
  const location = useLocation();

  // Admin login-as-owner lands with tokens in the hash — store cookies first
  applyAuthTokensFromUrl();
  const isAuthenticated = !!Cookies.get("accessToken");

  if (!isAuthenticated) {
    const loginPath = location.pathname.startsWith("/owner-account")
      ? "/ownerlogin"
      : "/login";
    return <Navigate to={loginPath} replace />;
  }

  return element;
};

export default PrivateRoute;
